/**
 * 점검 목록 테이블
 */
import React from 'react';
import { Maintenance } from '../types/maintenance.types';
import { CommonCodeDto } from '@/shared/types/commonCode.types';
import { format } from 'date-fns';

interface MaintenanceTableProps {
    maintenances: Maintenance[];
    loading: boolean;
    msgCodes: CommonCodeDto[];
    onEdit: (maintenance: Maintenance) => void;
    onDelete: (seqNo: number) => void;
}

export const MaintenanceTable: React.FC<MaintenanceTableProps> = ({
                                                                      maintenances,
                                                                      loading,
                                                                      msgCodes,
                                                                      onEdit,
                                                                      onDelete
                                                                  }) => {
    // 문구 코드명 조회
    const getMsgCodeName = (msgCode: string): string => {
        const code = msgCodes.find(c => c.comCode === msgCode);
        return code?.comCdName || msgCode;
    };

    // 점검 상태 확인
    const getStatus = (maintenance: Maintenance): { label: string; className: string } => {
        const now = new Date();
        if (maintenance.useYn !== 'Y') {
            return { label: '비활성', className: 'badge-secondary' };
        }
        if (now < maintenance.startDate) {
            return { label: '예정', className: 'badge-info' };
        }
        if (now >= maintenance.startDate && now <= maintenance.endDate) {
            return { label: '진행중', className: 'badge-danger' };
        }
        return { label: '종료', className: 'badge-success' };
    };

    if (loading) {
        return <div className="loading-container">로딩 중...</div>;
    }

    if (maintenances.length === 0) {
        return <div className="empty-container">등록된 점검이 없습니다.</div>;
    }

    return (
        <div className="table-container">
            <table className="data-table">
                <thead>
                <tr>
                    <th>번호</th>
                    <th>상태</th>
                    <th>점검 시작</th>
                    <th>점검 종료</th>
                    <th>점검 문구</th>
                    <th>등록자</th>
                    <th>등록일시</th>
                    <th>관리</th>
                </tr>
                </thead>
                <tbody>
                {maintenances.map((maintenance) => {
                    const status = getStatus(maintenance);
                    return (
                        <tr key={maintenance.seqNo}>
                            <td>{maintenance.seqNo}</td>
                            <td>
                                      <span className={`badge ${status.className}`}>
                                          {status.label}
                                      </span>
                            </td>
                            <td>{format(maintenance.startDate, 'yyyy-MM-dd HH:mm')}</td>
                            <td>{format(maintenance.endDate, 'yyyy-MM-dd HH:mm')}</td>
                            <td className="msg-cell">
                                {maintenance.msgCode === 'CUSTM'
                                    ? maintenance.msgContent
                                    : getMsgCodeName(maintenance.msgCode)}
                            </td>
                            <td>{maintenance.insUser || '-'}</td>
                            <td>
                                {maintenance.insDate
                                    ? format(maintenance.insDate, 'yyyy-MM-dd HH:mm')
                                    : '-'}
                            </td>
                            <td>
                                <div className="action-buttons">
                                    <button
                                        className="btn btn-sm btn-maintenance-edit"
                                        onClick={() => onEdit(maintenance)}
                                    >
                                        수정
                                    </button>
                                    <button
                                        className="btn btn-sm btn-maintenance-delete"
                                        onClick={() => onDelete(maintenance.seqNo)}
                                    >
                                        삭제
                                    </button>
                                </div>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};
